const GetRequestStyle = (status,type='label') => {

    let label;
    let heading;
    let color;
    let bgColor;

    switch (status) {
        case 'awaiting-price-confirmation':
            label = 'بإنتظار تأكيد السعر الجديد';
            heading = 'طلب قيد التأكيد';
            color = 'text-priceChange';
            bgColor = 'bg-priceChange';
            break;
        case 'pending-approval':
            label = 'في انتظار قرار المدير';
            heading = 'الطلب يحتاج الي مراجعه من المدير';
            color = 'text-pandingOps';
            bgColor = 'bg-pandingOps';
            break;
        case 'pending-operations':
            label = 'في انتظار قرار ادارة فني';
            heading = 'الطلب يحتاج الي مراجعه من ادارة فني';
            color = 'text-pandingOps';
            bgColor = 'bg-pandingOps';
            break;
        case 'pending':
            label = 'بانتظار التأكيد';
            heading = 'طلب يحتاج الي تاكيد';
            color = 'text-orange';
            bgColor = 'bg-orange';
            break;
        case 'done':
            label = 'مكتمل';
            heading = 'تم اكتمال الطلب';
            color = 'text-success';
            bgColor = 'bg-success';
            break;
        case 'active':
            label = 'تحت العمل';
            heading = 'الطلب تحت العمل';
            color = 'text-blue';
            bgColor = 'bg-blue';
            break;
        case 'canceled':
            label = 'ملغاة';
            heading = 'الطلب ملغي';
            color = 'text-danger';
            bgColor = 'bg-danger';
            break;
        case 'rejected':
            label = 'مرفوض';
            heading = 'الطلب مرفوض';
            color = 'text-danger';
            bgColor = 'bg-danger';
            break;
        case 'postponed':
            label = 'تحت العمل';
            heading = 'الطلب تحت العمل';
            color = 'text-blue';
            bgColor = 'bg-blue';
            break;
    }

    if(type === 'label') {
        return label;
    } else if (type === 'heading') {
        return heading;
    } else if (type === 'bg') {
        return bgColor;
    } else if (type === 'color') {
        return color;
    }


}

export default GetRequestStyle;